import { useDroppable } from '@dnd-kit/core';
import React from 'react';

const DroppableUnassignedContainer = ({ children }) => {
  const { isOver, setNodeRef } = useDroppable({
    data: {
      type: 'unassigned',
    },
    id: 'unassigned-container',
  });

  return (
    <div
      ref={setNodeRef}
      className={`class-list__unassigned-container ${isOver ? 'dragging-over' : ''}`}
    >
      {children}
    </div>
  );
};

export default DroppableUnassignedContainer;

